/**
 * Provides basic JS functionality for the homepage hero.
 */

export class Hero {
  constructor(name, breakpoint) {
    this.name = name;
    this.breakpoint = breakpoint;
  }

  build() {
    if (document.querySelector(`${this.name} .video`)) {
      let $videoContainer = document.querySelector(`${this.name} .video`);
      let videoObj = drupalSettings.homepageHero.videos;
      if (this.breakpoint.matches && videoObj.length > 0) {
        $videoContainer.style.display = 'block';

        const $iframe = document.querySelector(`${this.name} iframe`);
        let windowSize = window.outerWidth;
        let newWidth = windowSize + windowSize * 0.57;
        let newHeight = newWidth * 0.36;

        if (
          navigator.userAgent.match(/iPhone|iPad|iPod/i) &&
          window.matchMedia('(min-width: 991px) and (max-width: 1024px)')
        ) {
          $iframe.style.width = '1024px';
          $iframe.style.height = '768px';
        } else {
          $iframe.style.width = newWidth + 'px';
          $iframe.style.height = newHeight + 'px';
        }

        let heroThumbnailURL = videoObj[0].fallback;
        let $heroThumbNail = `<img src="${heroThumbnailURL}" aria-hidden="true" alt="Background Video" class="video--thumbnail" />`;
        $iframe.insertAdjacentHTML('beforebegin', $heroThumbNail);
        $heroThumbNail = document.querySelectorAll(
          `${this.name} .video--thumbnail`
        );
        $iframe.onload = function () {
          gsap.to($heroThumbNail, {
            duration: 1,
            ease: 'power4.out',
            opacity: 0,
            delay: 1,
          });
        };

        let configuredUrl = `${videoObj[0].source.replace('/watch?v=', '/embed/')}?autoplay=1&controls=0&mute=1`;
        $iframe.setAttribute('src', configuredUrl);

        let mql = window.matchMedia('(max-width: 1439px)');
        mql.addEventListener('change', () => {
          windowSize = window.outerWidth;
          newWidth = windowSize + windowSize * 0.57;
          newHeight = newWidth * 0.36;
          $iframe.style.width = newWidth + 'px';
          $iframe.style.height = newHeight + 'px';
        });
      } else if (!this.breakpoint.matches && videoObj.length > 0) {
        let siteWrap = document.querySelector('.site-wrap');
        if (drupalSettings.homepageHero.images.length) {
          $videoContainer.style.display = 'none';
          let imageObj = drupalSettings.homepageHero.images;
          let $picture = document.createElement('picture');

          let randomImageItem =
            imageObj[Math.floor(Math.random() * imageObj.length)];

          randomImageItem.sources.forEach((source) => {
            let $source = document.createElement('source');
            let srcSet = source.srcset;
            let mediaSize = source.media;
            let mediaType = source.type;

            $source.setAttribute('srcset', srcSet);
            $source.setAttribute('media', mediaSize);
            $source.setAttribute('type', mediaType);

            $picture.appendChild($source);
          });

          let $image = document.createElement('img');

          let fallbackSrc = randomImageItem.fallback;
          $image.setAttribute('src', fallbackSrc);
          $image.setAttribute('aria-hidden', 'true');
          $image.setAttribute('alt', 'Background Image');
          $picture.appendChild($image);

          document.querySelector(`${this.name} .image`).appendChild($picture);
        } else {
          if (siteWrap.classList.contains('with-hero-background')) {
            siteWrap.classList.remove('with-hero-background');
            siteWrap.classList.add('without-hero-background');
          }
        }
      } else if (drupalSettings.homepageHero.images.length) {
        $videoContainer.style.display = 'none';

        let imageObj = drupalSettings.homepageHero.images;
        let $picture = document.createElement('picture');

        let randomImageItem =
          imageObj[Math.floor(Math.random() * imageObj.length)];

        randomImageItem.sources.forEach((source) => {
          let $source = document.createElement('source');
          let srcSet = source.srcset;
          let mediaSize = source.media;
          let mediaType = source.type;

          $source.setAttribute('srcset', srcSet);
          $source.setAttribute('media', mediaSize);
          $source.setAttribute('type', mediaType);

          $picture.appendChild($source);
        });

        let $image = document.createElement('img');

        let fallbackSrc = randomImageItem.fallback;
        $image.setAttribute('src', fallbackSrc);
        $image.setAttribute('aria-hidden', 'true');
        $image.setAttribute('alt', 'Background Image');
        $picture.appendChild($image);

        document.querySelector(`${this.name} .image`).appendChild($picture);
      } else {
        document
          .querySelector(`${this.name} .interior-hero--background`)
          .remove();
      }
    }
  }
}
